<div class="container p-4">
  <div class="row justify-content-center">
    <div class="col-12 col-xxl-10">
      <div *ngIf="!isSystem" class="col-12 text-center p-4" style="color: grey;">
        {{'SYSTEM.SYSTEMLIST.EMPTY' | translate }}
      </div>
      <div class="card mt-4" *ngFor="let system of systemsList">
        <div class="card-header noPointer p-0">
          <div class="row justify-content-center align-items-center">
            <div class="col-12 text-center" (click)="systemOverview(system.id)">
              <span style="font-weight: 400;" class="systemTitle">{{system.system_name}}</span>
          </div>
          <div class="row justify-content-center align-items-center">
            <div class="col-6 text-start pe-0">
              <i class="bi bi-circle-fill status me-1" matTooltip="Status: {{system.status?.name}}"
                [ngStyle]="{'color':  '#'+system.status?.color}">
              </i>
              <span class="d-none d-sm-inline" style="font-size: small;">{{system.status?.name}}</span>
            </div>
            <div class="col-6 text-end">
              <i class="bi bi-trash iconCursor me-2" style="color: #ca2314;" (click)="deleteSystem(system.id)"></i>
            </div>
          </div>
          </div>
        </div>
        <div class="card-body" (click)="systemOverview(system.id)">
          <div class="row g-0">

            <!-- DESCRIPTION -->
            <div class="col-12 element text-center">
              <div class="row g-0">
                <div class="col-12 p-0" style="border-bottom: 1px solid #e0e0e0;">
                  <span style="font-weight: bold;">
                    {{'SYSTEM.SYSTEMLIST.SYSTEMCARD.DESCRIPTION' | translate}}
                  </span><br>
                </div>
              </div>
              <div *ngIf="system.system_description; else noDescriptionBlock" class="content fst-italic">{{system.system_description}}</div>
              <ng-template #noDescriptionBlock>
                <div class="content fst-italic">{{'SYSTEM.SYSTEMLIST.SYSTEMCARD.NODESCRIPTION' | translate}}</div>
              </ng-template>
            </div>

            <!-- INSTALLATION SITE -->
            <div class="col-12 col-md-6 element text-center">
              <div class="row g-0">
                <div class="col-12 p-0" style="border-bottom: 1px solid #e0e0e0;">
                  <span style="font-weight: bold;">
                    {{'SYSTEM.SYSTEMLIST.SYSTEMCARD.INSTALLATIONSITE' | translate }}
                  </span><br>
                </div>
              </div>
              <div class="content">{{system.installationSite}}</div>
            </div>

            <!-- CUSTOMER -->
            <div class="col-12 col-md-6 element text-center">
              <div class="row g-0">
                <div class="col-12 p-0" style="border-bottom: 1px solid #e0e0e0;">
                  <span style="font-weight: bold;">
                    {{'SYSTEM.SYSTEMLIST.SYSTEMCARD.CUSTOMER' | translate }}</span><br>
                </div>
              </div>
              <div class="content">{{system.customerInfo}}</div>
            </div>

            <!-- TICKET -->
            <div class="col-12 col-md-6 element text-center">
              <div class="row g-0">
                <div class="col-12 p-0" style="border-bottom: 1px solid #e0e0e0;"
                  [ngStyle]="{'background-color': (system.ticketsInfo.opened != 0 || system.ticketsInfo.closed != 0) ? '#fcf3cf' : 'none'}">
                  <span style="font-weight: bold;">
                    {{'SYSTEM.SYSTEMLIST.SYSTEMCARD.TICKETS' | translate }}
                  </span><br>
                </div>
              </div>
              <div class="content">
                <div *ngIf="system.ticketsInfo.opened != 0 || system.ticketsInfo.closed != 0; else noSupportRequested" 
                  class="row justify-content-evenly p-0">
                  <div class="col-12 col-md-5 text-center p-0">
                    {{'SYSTEM.SYSTEMLIST.SYSTEMCARD.OPENEDTICKETS' | translate}}: {{system.ticketsInfo.opened}}
                  </div>
                  <div class="col-12 col-md-5 text-center p-0">
                    {{'SYSTEM.SYSTEMLIST.SYSTEMCARD.CLOSEDTICKETS' | translate}}: {{system.ticketsInfo.closed}}
                  </div>
                </div>
                <ng-template #noSupportRequested>
                  <span>
                    {{'SYSTEM.SYSTEMLIST.SYSTEMCARD.NOSUPPORTREQUESTED' | translate }}
                  </span>
                </ng-template>
              </div>
            </div>

            <!-- RMA -->
            <div class="col-12 col-md-6 element text-center">
              <div class="row g-0">
                <div class="col-12 p-0" style="border-bottom: 1px solid #e0e0e0;">
                  <span style="font-weight: bold;">
                    {{'SYSTEM.SYSTEMLIST.SYSTEMCARD.RMA' | translate }}
                  </span><br>
                </div>
              </div>
              <div class="content">
                <span>
                  {{'SYSTEM.SYSTEMLIST.SYSTEMCARD.NOSUPPORTREQUESTED' | translate }}
                </span>
              </div>
            </div>

            <!-- <div class="col-12 col-md-6 element text-center">
              <div class="row g-0">
                <div class="col-12 p-0" style="border-bottom: 1px solid #e0e0e0;">
                  <span style="font-weight: bold;">{{'SYSTEM.SYSTEMLIST.SYSTEMCARD.DEVICES' |
                    translate }}</span><br>
                </div>
              </div>
              <div class="content">
                <span *ngFor="let device of system.devicesInfo">
                  {{device}}<br>
                </span>
              </div>
            </div> -->

            <!--
            <div class="col-12 col-md-6 element text-center">
              <div class="row g-0">
                <div class="col-12 p-0" style="border-bottom: 1px solid #e0e0e0;">
                  <span style="font-weight: bold;">{{'SYSTEM.SYSTEMLIST.SYSTEMCARD.WARRANTY' | translate }}</span><br>
                </div>
              </div>
            </div> -->
            <!--<div class="row">
            <div class="col-12 col-md-6 mt-2">
              <span style="font-weight: bold;">Supplier Name:</span><br>
              <div class="content">{{system.customerName}}</div>
            </div>
            <div class="col-12 col-md-6 mt-2">
              <span style="font-weight: bold;">System Description:</span><br>
              <div class="content">{{system.description}}</div>
            </div>
            <div class="col-12 col-md-6 mt-2">
              <span style="font-weight: bold;">installation Site:</span><br>
              <div class="content">{{system.installationSite}}</div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>